import React, { useEffect, useRef } from 'react';
import Container from './Container';
import '../styles/unigs.css';
import { Helmet ,HelmetProvider} from "react-helmet-async";

const UnigsSection = () => {
  const sectionRef = useRef(null);
  const APP_STORE_URL = "https://www.apple.com/app-store/";

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <>
    <HelmetProvider>
      <Helmet>
   <meta
    name="description"
    content="UNIGS by INBI NextGen Innovations makes cooperative society mobile banking effortless. Access SB, Pigmy, and Loan accounts, make payments, and manage EMI securely."
  />
  <meta name="keywords" content="UNIGS, cooperative society banking, mobile banking app, INBI UNIGS, digital cooperative solutions" />

  {/* Open Graph */}
  <meta property="og:title" content="UNIGS – Unified Information Gateway System" />
  <meta property="og:description" content="Simplifying cooperative society banking with INBI NextGen Innovations UNIGS platform." />
  <meta property="og:image" content="/assets/Logoblue.jpg" />
  <meta property="og:url" content="https://inbinextgen.com/#unigs" />
  <meta property="og:type" content="website" />

  {/* Twitter */}
  <meta name="twitter:title" content="UNIGS – Unified Information Gateway System" />
  <meta name="twitter:description" content="Your cooperative society, simplified. Access accounts, pay EMI, and manage finances with UNIGS." />
  <meta name="twitter:image" content="/assets/Logoblue.jpg" />
  </Helmet>
    </HelmetProvider>
    
    <section ref={sectionRef} id="unigs" className="unigs-section">
      <div className="unigs-container">
        <div className="unigs-content">
          
          <div className="unigs-image">
            <img src="/assets/UNIGS.svg" alt="UNIGS App" />
          </div>
          <div className="unigs-text">
            <img
              src="/assets/UNIGS_logo.svg"
              alt=" UNIGS – Unified Information Gateway System "
              className="unigs-logo"
            />
          <h3>Unified Information Gateway System</h3>
          <b>Your Cooperative Society, Simplified</b>
          <p>
            UNIGS is our flagship platform designed to make cooperative societies online mobile banking effortless.
          </p>

          <h3>With UNIGS, you can: </h3>
          <ul>
            <li>Access SB, Pigmy, and Loan Accounts from Mobile App </li>
            <li>Make secure online payments to repay EMI </li>
            <li>Receive offers and important updates from the society </li>
            <li>Enjoy a smooth, easy-to-use mobile experience </li>
          </ul>
          
          <div className="unigs-buttons">
              <a
                href="https://play.google.com/store/apps/details?id=com.inbi.unigs"
                target="_blank"
                rel="noopener noreferrer"
                className="play-store-button"
              >
              <img
                src="/assets/Playstore.svg"
                alt="Google Play Store"
              />
            </a>
               <a
                 href="https://apps.apple.com/in/app/unigs/id6752995958"
                target="_blank"
                rel="noopener noreferrer"
                className="play-store-button"
              >
              <img
                src="/assets/appstore.png"
                alt="Apple App Store"
                className="app-store-badge"
              />
            </a>
            {/* <button
              className="know-more-button"
              onClick={() => window.open("https://unigs.in/", "_blank", "noopener,noreferrer")}
              aria-label="Know more about Unigs"
            >
              Know 
            </button> */}
          </div> 
        </div>
          
          
        </div>
      </div>
      
    </section>
    </>
    
       
    
  );
};

export default UnigsSection;
